import { render, staticRenderFns } from "./NewReservation.vue?vue&type=template&id=6ebfc156"
import script from "./NewReservation.vue?vue&type=script&lang=js"
export * from "./NewReservation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports